'use strict';

import React from 'react';
import flux from 'utils/flux';
import videojs from 'video.js';
import videoJsResolutionSwitcher from 'videojs-resolution-switcher';
import { Link } from 'react-router';
import queryString from 'query-string';
import dom from 'utils/dom';
import api from 'utils/api';
import classnames from 'classnames';
import prettyBytes from 'pretty-bytes';
import screenfull from 'screenfull';

var MediaModal = React.createClass({

    displayName: 'MediaModal',

    propTypes: {
        media: React.PropTypes.object
    },

    getInitialState() {
        return {
            autoResolution: true
        }
    },

    componentDidMount() {
        if ( 'video' === this.props.media.type ) {
            this.setupVideoPlayer();
        }
        else if ( Modernizr && !Modernizr.objectfit ) {
            // Polyfill object-fit: contain
            var image  = this.refs.preview.getDOMNode(),
                parent = image.parentNode;

            if ( !parent ) return;

            image.style.display = 'none';
            parent.style.backgroundImage = 'url(' + image.src + ')';
        }

        window.addEventListener( 'resize', this, false );
        document.addEventListener( 'fullscreenchange', this, false );
        document.addEventListener( 'mozfullscreenchange', this, false );
        document.addEventListener( 'webkitfullscreenchange', this, false );
        document.addEventListener( 'click', this, true );
        this.resize();
    },

    componentWillUnmount() {
        if (this.player) {
            this.player.dispose();
        }
        window.removeEventListener( 'resize', this, false );
        document.removeEventListener( 'fullscreenchange', this, false );
        document.removeEventListener( 'mozfullscreenchange', this, false );
        document.removeEventListener( 'webkitfullscreenchange', this, false );
        document.removeEventListener( 'click', this, true );
    },

    handleEvent(e) {
        if ( 'resize' === e.type ) {
            window.requestAnimationFrame && window.requestAnimationFrame( this.resize );
            !window.requestAnimationFrame && this.resize();
        }
        else if ( e.type.indexOf( 'fullscreenchange' ) > -1 ) {
            this.updateVideoResolution();
        }
        else if ( 'click' === e.type ) {
            const { target, target: { className } } = e;
            if ( className.indexOf('vjs-menu-item') > -1 && target.parentNode.parentNode.parentNode.className.indexOf('vjs-resolution-button') > -1 ) {
                this.setState({
                    autoResolution: false
                });
            }
        }
    },

    setupVideoPlayer() {
        if ( 'video' !== this.props.media.type ) {
            return;
        }

        var media        = this.props.media;
        var videoWrapper = document.createElement('VIDEO');
        var video        = this.refs.video.getDOMNode();
        var hasQualities = !!media.videos.find( video => !!video.quality );

        dom.setAttributes( videoWrapper, {
            'class':  'video-js vjs-default-skin',
            controls: true,
            preload:  'auto',
            poster:   api.cachedImagePath( media.thumbnails.preview.src )
        });

        const mapQualToLabel = quality => {
            switch ( quality ) {
                case 'full':
                    return {
                        label: 'HD',
                        res: 1080
                    };
                case 'low':
                    return {
                        label: 'SD',
                        res: 720
                    };
            }
            return {
                label: quality,
                res: null
            };
        }

        var sources = [];

        media.videos.forEach( video => {
            const quality = mapQualToLabel(video.quality);
            sources.push({
                src:    video.url,
                type:   video.mimeType,
                label:  quality.label,
                res:    quality.res
            });
        });

        video.appendChild( videoWrapper );

        this.player = videojs( videoWrapper, {
            sources,
            plugins: {
                videoJsResolutionSwitcher: {
                    'default': 'low'
                }
            }
        });
    },

    updateVideoResolution() {
        const { autoResolution } = this.state;

        if ( !autoResolution ) {
            return;
        }

        if ( screenfull.isFullscreen ) {
            this.player.currentResolution('HD');
        }
        else {
            this.player.currentResolution('SD');
        }
    },

    resize() {
        var previewImg = this.props.media.thumbnails.preview,
            previewImgRatio =
                ( this._cache && this._cache.previewImgRatio ) ||
                ( previewImg.width / previewImg.height ),
            desiredHeight,
            maxHeight;

        const { type } = this.props.media;

        // constants
        var MARGIN = 20,
            RATIO  = 16 / 9;

        if ( this._cache && window.innerHeight === this._cache.windowHeight ) {
            return;
        }
        else if ( !this._cache ) {
            this._cache = {
                descEl:    this.refs.description.getDOMNode(),
                previewEl:
                    this.refs.preview ?
                        this.refs.preview.getDOMNode().parentNode :
                        this.refs.video.getDOMNode().childNodes[0],
                contentEl: this.refs.modalInner.getDOMNode().parentNode,
                previewImgRatio: previewImgRatio
            }
        }
        this._cache.windowHeight      = window.innerHeight;
        this._cache.descriptionHeight = this._cache.descEl.offsetHeight;
        this._cache.previewWidth      = this._cache.previewEl.offsetWidth;

        if ( 'video' !== type && previewImgRatio < RATIO ) {
            // adjust container size
            desiredHeight = this._cache.previewWidth / previewImgRatio;
            maxHeight = this._cache.windowHeight - this._cache.descriptionHeight - ( MARGIN * 2 );
            this._cache.previewEl.style.paddingTop = ( Math.min( desiredHeight, maxHeight ) / this._cache.previewWidth * 100 ).toFixed(3) + '%';
        }

        // center vertically
        var marginTop = 'video' !== type ?
            Math.floor(
                Math.max(
                    MARGIN,
                    ( this._cache.windowHeight - this._cache.contentEl.offsetHeight ) / 2
                )
            ) :
            Math.floor(
                Math.max(
                    MARGIN,
                    ( this._cache.windowHeight - ( this._cache.contentEl.offsetWidth / RATIO + this._cache.descriptionHeight ) ) / 2
                )
            );
        this._cache.contentEl.style.marginTop = marginTop + 'px';
    },

    renderMediaPreview() {
        var media = this.props.media;
        var mediaType = media.type;

        if ( 'video' === mediaType ) {
            return(
                <div className="media__video">
                    <div ref="video" />
                </div>
            );
        }

        var previewImage = media.thumbnails.preview;

        return (
            <div className={classnames( 'media__image', 'media__image--type__' + mediaType )}>
                {(() => {
                    if ( previewImage ) {
                        return (
                            <img className="media__preview__image" src={previewImage.src} width={previewImage.width} height={previewImage.height} ref="preview" />
                        );
                    }
                })()}
            </div>
        );
    },

    renderTags() {
        if ( !this.props.media.tags || this.props.media.tags.length <= 0 ) {
            return;
        }

        return (
            <div className="description__tags">
                <span className="tags__title">{flux.t('tags')}:</span>
                {this.props.media.tags.map( (tag, ix) => {
                    return (
                        <Link key={'tag_'+ix} onClick={flux.getActions('modals').closeModals} to="listing" className="btn btn-small btn-primary tags__button" query={queryString.parse(tag.link)}>{tag.name}</Link>
                    );
                })}
            </div>
        );
    },

    render() {
        if ( !this.props.media ) {
            return;
        }

        var restrictedKeys = ['MICode'];
        var media = this.props.media;

        var mediaTitle = (media.title && media.title.length) ? media.title : media.name;
        var master     = media.files.find( file => 'master' === file.key );
        var MICode     = media.meta.length > 0 && media.meta.find( meta => 'MICode' === meta.key );

        return (
            <div ref="modalInner">
                {this.renderMediaPreview()}
                <div className="media__description" ref="description">
                    <div className="description__info">
                        <h4 title={mediaTitle}>{mediaTitle}</h4>
                        <p>{media.description}</p>
                        {MICode && <strong>{MICode.value}</strong>}
                        {media.additionalText && <strong>{media.additionalText}</strong>}
                        {master && <span>Master: {master.mimeType + '\u00a0/\u00a0' + prettyBytes(master.size)}</span>}
                    </div>
                    <div className="description__meta">
                    </div>
                    {this.renderTags()}
                </div>
            </div>
        );
    }
});

module.exports = MediaModal;



// WEBPACK FOOTER //
// ./app/components/modals/mediaModal.jsx